// Transition overlap for seamless push transition between Scene 2 and Scene 3a
export const TRANSITION_OVERLAP = 30; // ~1.1 second overlap at 30fps
export const TRANSITION_DURATION = 30; // 1 second fade duration

// Scene 3 to Scene 4 overlap timing
export const SCENE_3A_3B_OVERLAP_FRAMES = 30;
export const SCENE_3B_FADE_IN_DURATION = 10;
export const SCENE_3A_BACKGROUND_FADE_OUT_DURATION = 10;
export const SCENE_3A_TEXT_FADE_OUT_DURATION = 20;

// Scene3b text fade out before transition
export const SCENE_3B_TEXT_FADE_OUT_DURATION = 20; // ~0.67 seconds at 30fps

// Diagonal wipe transition from Scene3b to Scene4
export const DIAGONAL_WIPE_EXPAND_DURATION = 20; // ~0.67 seconds at 30fps (faster expand)
export const DIAGONAL_WIPE_HOLD_DURATION = 0; // No pause, collapse starts immediately
export const DIAGONAL_WIPE_COLLAPSE_DURATION = 50; // ~1.67 seconds at 30fps (faster reveal)
export const DIAGONAL_WIPE_TOTAL_DURATION =
  DIAGONAL_WIPE_EXPAND_DURATION +
  DIAGONAL_WIPE_HOLD_DURATION +
  DIAGONAL_WIPE_COLLAPSE_DURATION; // 70 frames total (~2.33s)

// Scene 4 to Scene 5a zoom transition
export const ZOOM_TRANSITION_DURATION = 30; // 1 second overlap at 30fps

// Scene 5a to Scene 5b transition overlap
export const SCENE_5A_5B_OVERLAP = 15; // ~0.5 second overlap at 30fps

// Scene 5b to Scene 5c transition overlap
export const SCENE_5B_5C_OVERLAP = 65; // ~2.3 second overlap at 30fps

// Scene 5b to Scene 6 fade-in transition
export const SCENE_5B_6_FADE_IN_DURATION = 20; // ~0.67 second fade at 30fps

// Scene 5 (empty training) fade-in from previous scene
export const SCENE_5_FADE_IN_DURATION = 20; // ~0.67 second fade at 30fps

// Scene 5/5c to Scene 6 slide transition
export const SCENE_6_SLIDE_IN_DURATION = 35; // ~1.17 second slide at 30fps

// Scene 6 to Scene 7 cross zoom transition
export const CROSS_ZOOM_TRANSITION_DURATION = 20; // ~0.67 seconds overlap at 30fps
export const SCENE_7_ANIMATION_DELAY_OFFSET = 15; // frames after cross-zoom before content animates

// Scene 7 to Scene 8 exit transition (~1 second at 30fps)
export const SCENE_7_8_EXIT_DURATION = 30; // Cards and labels slide out together
export const SCENE_7_8_BACKGROUND_FADE_DELAY = 8; // Background fade starts after this delay
export const SCENE_7_8_BACKGROUND_FADE_DURATION = 20; // Background fade duration
export const SCENE_7_8_TRANSITION_DURATION = Math.max(
  SCENE_7_8_EXIT_DURATION, // Total transition is the longer of, exit animation
  SCENE_7_8_BACKGROUND_FADE_DELAY + SCENE_7_8_BACKGROUND_FADE_DURATION, // or background fade (delay + duration)
);

// Scene 8 (closing) fade-in duration after Scene 7 exit
export const SCENE_8_FADE_IN_DURATION = 20;

// Scene durations
const SCENE_1_DURATION = 150; // 5 seconds
const SCENE_2_DURATION = 360; // 12 seconds
const SCENE_3A_DURATION = 180; // 6 seconds
const SCENE_3B_DURATION = 380; // ~12.6 seconds to display all projects
// Note: SCENE_4_DURATION is calculated dynamically
const SCENE_5A_DURATION = 180; // 6 seconds
const SCENE_5B_DURATION = 180; // 6 seconds
export const SCENE_5_DURATION = 300; // 10 seconds (empty training scene)
const SCENE_6_DURATION = 300; // 10 seconds
const SCENE_7_DURATION = 360; // 12 seconds
export const SCENE_8_DURATION = 280; // ~9.33 seconds

// Calculated timing
const SCENE_2_START = SCENE_1_DURATION;
const SCENE_2_END = SCENE_2_START + SCENE_2_DURATION;
const SCENE_3A_START = SCENE_2_END - TRANSITION_OVERLAP;

export const EMPLOYEE_YEAR_IN_REVIEW_CONFIG = {
  timing: {
    slide1: {
      start: 0,
      duration: SCENE_1_DURATION,
    },
    slide2: {
      start: SCENE_2_START,
      duration: SCENE_2_DURATION,
    },
    slide3a: {
      start: SCENE_3A_START,
      duration: SCENE_3A_DURATION + TRANSITION_OVERLAP, // Compensate for overlap
    },
    slide3b: {
      duration: SCENE_3B_DURATION,
    },
    // Note: slide4 duration is calculated dynamically
    slide5a: {
      duration: SCENE_5A_DURATION,
    },
    slide5b: {
      duration: SCENE_5B_DURATION,
    },
    slide6a: {
      duration: SCENE_6_DURATION,
    },
    slide7: {
      duration: SCENE_7_DURATION,
    },
    slide8: {
      duration: SCENE_8_DURATION,
    },
  },
  transition: {
    fadeOutDuration: TRANSITION_DURATION,
    overlapDuration: TRANSITION_OVERLAP,
  },
};
